import React from 'react'
import PropTypes from 'prop-types'
import './style.css'


const NRTVerticalStack = (props) => {
    return (
        <div className={'nrt-form-vertical-stack'} style={props.style}>
            {props.children}
        </div>
    )
}

NRTVerticalStack.propTypes = {
    style: PropTypes.object,
}

NRTVerticalStack.defaultProps = {
    style: {}
}

export default NRTVerticalStack



// WEBPACK FOOTER //
// ./src/components/_common/_containers/VerticalStack/index.js